module.exports = __webpack_public_path__ + "img/3-2.ae4275cf.png";